import * as React from 'react';
import PropTypes from 'prop-types';
import Popover from 'react-simple-popover';
import { findDOMNode } from 'react-dom';
import { I18n } from 'react-redux-i18n-lite';
import SanitizedString from '../../../../common/SanitizedString';

export class TopRowIcons extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      visiblePopover: false,
      style: {
        left: undefined,
        right: undefined,
        borderColor: undefined
      }
    };
    this.showPopover = this.showPopover.bind(this);
    this.hidePopover = this.hidePopover.bind(this);
    this.getContainer = this.getContainer.bind(this);
    this.setPopoverPosition = this.setPopoverPosition.bind(this);
  }

  static propTypes = {
    index: PropTypes.number,
    group: PropTypes.object,
    item: PropTypes.object,
    icon: PropTypes.string,
    color: PropTypes.string,
    gradeTypes: PropTypes.string,
    setSelectedBook: PropTypes.func,
    setSelectedUnit: PropTypes.func,
    setSelectedLesson: PropTypes.func,
    routeParams: PropTypes.object,
    sectionId: PropTypes.string,
    isAssessable: PropTypes.bool
  };

  setPopoverPosition() {
    /* eslint-disable */
    let pos = findDOMNode(this.buttonNode).getBoundingClientRect();
    /* eslint-enable */
    let style = Object.assign({}, this.state.style);
    style.left = pos.left + 3;
    style.top = pos.top + 13;
    style.borderColor = `transparent transparent ${this.props.color}`;
    this.setState({ style });
  }

  showPopover() {
    this.setPopoverPosition();
    this.setState({ visiblePopover: true });
  }

  hidePopover() {
    this.setState({ visiblePopover: false });
  }

  getContainer() {
    return this.buttonNode;
  }

  handleClickItem = item => {
    const { gradeTypes, setSelectedUnit, setSelectedLesson } = this.props;
    if (gradeTypes === 'unit') {
      return setSelectedUnit(item, this.props.sectionId);
    }
    if (gradeTypes === 'lesson') {
      return setSelectedLesson(item, this.props.sectionId);
    }
  };

  buttonNode = null;

  getColorClass(isUnitAssessable, isActivityDisabled, color, prop, isArrow) {
    if (!isUnitAssessable) return 'non-assessable' + prop;

    if (isActivityDisabled) return 'activity-disabled' + prop;

    if (isArrow) return color;

    return color + prop;
  }

  render() {
    const { visiblePopover, style } = this.state;
    const { item, color, icon, isAssessable } = this.props;
    return (
      <div
        className={`open-popover ${isAssessable ? '' : 'cursor-default'}`}
        onClick={isAssessable ? this.handleClickItem.bind(this, item) : undefined}
        onMouseLeave={this.hidePopover}
        onMouseEnter={this.showPopover}
      >
        <span
          ref={node => {
            this.buttonNode = node;
          }}
          className={`custom-icons-${icon} icons ${this.getColorClass(isAssessable, item.disabled, color, '-color')}`}
        ></span>
        <div className="popover-wrapper">
          <Popover
            target={this.getContainer()}
            placement="bottom"
            style={{ padding: '0px', width: 'fit-content', boxShadow: 'none', backgroundColor: '#ffffff00' }}
            show={visiblePopover}
          >
            <div>
              <div className="arrow">
                <div
                  className={`blue-icon ${this.getColorClass(isAssessable, item.disabled, color, '-color', true)}`}
                  style={style}
                ></div>
                <div className="white-icon" style={style}></div>
              </div>
              <div className="simple-popover">
                <div
                  className={`popover-shape ${this.getColorClass(isAssessable, item.disabled, color, '-border-color')}`}
                >
                  <div className="popover-text">
                    <SanitizedString rawString={item.name} />
                    {!isAssessable ? (
                      <div>
                        {I18n.t('gradebook.noActivity') + '. '}
                        {I18n.t('gradebook.noAssessable') + '.'}
                      </div>
                    ) : (
                      undefined
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Popover>
        </div>
      </div>
    );
  }
}

export default TopRowIcons;
